import React from "react";
import { InputGroup, Input } from "reactstrap";

export const SearchBox = ({ changeValue, text, ...props }) => (
  <InputGroup>
    <div className="input-group-prepend" style={{borderLeft: "4px solid #cfd8dc", borderRadius: "0px"}}>
      <span className="input-group-text" style={{borderRadius: "0px"}}>
        <i className="fa fa-search" />
      </span>
    </div>
    <Input
      type="text"
      placeholder="Search something"
      value={text}
      onChange={(e) => changeValue({ text: e.target.value })}
    />
  </InputGroup>
);

